import bugsnag from "bugsnag-js"
import createPlugin from "bugsnag-react"
import React from "react"
import Layout from './components/Layout/Index'
import Public from './components/Layout/Public'
import { authProtectedRoutes, publicRoutes } from "./routes/"
import AppRoute from "./routes/route"
import { Switch, BrowserRouter as Router } from "react-router-dom"
import { GeneralContextProvider } from './context'

import "./assets/scss/theme.scss"

const bugsnagClient = bugsnag("63a85cb7c719e745236cff5bf26881f4")
const ErrorBoundary = bugsnagClient.use(createPlugin(React))

const App = () => {
    return (
        <React.Fragment>
            <GeneralContextProvider>
                <ErrorBoundary>
                    <Router>
                        <Switch>
                            {publicRoutes.map((route, idx) => (
                                <AppRoute
                                    path={route.path}
                                    layout={Public}
                                    component={route.component}
                                    key={idx}
                                    isAuthProtected={false}
                                />
                            ))}

                            {authProtectedRoutes.map((route, idx) => (
                                <AppRoute
                                    path={route.path}
                                    layout={Layout}
                                    component={route.component}
                                    key={idx}
                                    isAuthProtected={true}
                                    allowedRoles={route.allowedRoles}
                                />
                            ))}
                        </Switch>
                    </Router>
                </ErrorBoundary>
            </GeneralContextProvider>
        </React.Fragment>
    )
}

export default App
